import { AppContainerComponent } from './app-container/app-container.component';
import { ControlDatepickerComponent } from './common-controls/control-datepicker/control-datepicker.component';
import { ControlTextAreaComponent } from './common-controls/control-textarea/control-textarea.component';
import { ControlInputComponent } from './common-controls/control-input/control-input.component';
import { ControlCheckboxComponent } from './common-controls/control-checkbox/control-checkbox.component';
import { ControlSelectComponent } from './common-controls/control-select/control-select.component';
import { ControlSelectMultipleComponent } from './common-controls/control-select-multiple/control-select-multiple.component';
import { ControlAutocompleteComponent } from './common-controls/control-autocomplete/control-autocomplete.component';
import { AutomaticFormsComponent } from './automatic-forms/automatic-forms.component';
import { ListTableComponent, getCellDataPipe, orderTableColumns } from './list-table/list-table.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { ControlChipsComponent } from './common-controls/control-chips/control-chips.component';
import { ControlChipsTextComponent } from './common-controls/control-chips-text/control-chips-text.component';
import { ControlUploadComponent } from './common-controls/control-upload/control-upload.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { ControlMaskedInputComponent } from './common-controls/control-masked-input/control-masked-input.component';
import { ControlReadOnlyComponent } from './common-controls/control-read-only/control-read-only.component';
import { AttachmentComponent } from './attachment/attachment.component';
import { DeleteDialogComponent } from './delete-dialog/delete-dialog.component';
// import { ControlTimepickerComponent } from './common-controls/control-timepicker/control-timepicker.component'
import { IconsByTypePipe } from './attachment/icons-by-type.pipe';
import { ControlRichTextComponent } from './common-controls/control-richtext/control-richtext.component';

// Componente base del control ControlPickList
import { PickTableComponent } from './common-controls/pick-table/pick-table.component';
// Selector de listas
import { ControlPickListComponent } from './common-controls/control-picklist/control-picklist.component'; 
// Componente base BelongsDiplomaComponent
import { BelongsDiplomaComponent } from './common-controls/belongs-diploma/belongs-diploma.component';
// Componente Belong Diploma
import { ControlBelongDiplomaComponent } from './common-controls/control-belongs-dipoma/control-belong-diploma.component';
import { ControlFullCalendarComponent } from './common-controls/control-fullcalendar/control-fullcalendar.component';
import { ControlTimeComponent } from './common-controls/control-time/control-time.component';
// COMPONENTE IMAGE PICKER E IMPAGE PRESENTER
import { ImagePickerComponent } from './common-controls/image-picker/image-picker.component';
import { ControlImagePickerComponent } from './common-controls/control-image-picker/control-image-picker.component';
import { ControlImagePresenterComponent } from './common-controls/control-image-presenter/control-image-presenter.component';
import { ControlSelectMultipleSearchComponent } from './common-controls/control-select-multiple-search/control-select-multiple-search.component';

import { ControlScheduleComponent } from './common-controls/control-schedule/control-schedule.component';
import { ControlNumericComponent } from './common-controls/control-numeric/control-numeric.component';

import { ControlShowItemComponent } from './common-controls/control-show-item/control-show-item.component';

import { ControlAutocompleteLocalComponent } from './common-controls/control-autocomplete-local/control-autocomplete-local.component';

import { NotificationDialogComponent } from './notification-dialog/notification-dialog.component';
import { ControlSchoolComponent } from './common-controls/control-school/control-school.component';
import { ControlStudentComponent } from './common-controls/control-student/control-student.component';
import { ControlRadioComponent } from './common-controls/control-radio/control-radio.component';
import { FilesDialogComponent } from './files-dialog/files-dialog.component';

export const components = [
    IconsByTypePipe,
    ControlReadOnlyComponent,
    ConfirmationDialogComponent,
    DeleteDialogComponent,
    LoginFormComponent,
    AttachmentComponent,
    getCellDataPipe,
    orderTableColumns,
    ListTableComponent,
    AutomaticFormsComponent,
    AppContainerComponent,
    ControlDatepickerComponent,
    ControlTextAreaComponent,
    ControlInputComponent,
    ControlCheckboxComponent,
    ControlSelectComponent,
    ControlSelectMultipleComponent,
    ControlSelectMultipleSearchComponent,
    ControlAutocompleteComponent,
    ControlChipsComponent,
    ControlChipsTextComponent,
    ControlUploadComponent,
    ControlRichTextComponent,
    PickTableComponent,
    ControlPickListComponent,
    BelongsDiplomaComponent,
    ControlBelongDiplomaComponent,
    ControlFullCalendarComponent,
    ControlTimeComponent,
    ControlMaskedInputComponent,
    ImagePickerComponent,
    ControlImagePickerComponent,
    ControlImagePresenterComponent,
    ControlScheduleComponent,
    ControlNumericComponent,
    ControlShowItemComponent,
    ControlAutocompleteLocalComponent,
    NotificationDialogComponent,
    FilesDialogComponent,
    ControlSchoolComponent,
    ControlStudentComponent,
    ControlRadioComponent,
]